import {createFileRoute} from '@tanstack/react-router';
import {companyAdminGranted, grantUser} from '@/practitioner/routing/utils/beforeLoadUtils';

import PathologyCustomizationCreate from '@/practitioner/views/company/PathologyCustomization/PathologyCustomizationCreate';

export const Route = createFileRoute('/(practitioner)/company/pathology-customization/create')({
  component: PathologyCustomizationCreate,
  beforeLoad: grantUser(companyAdminGranted)
});
